import paths from './paths';
import {
    getNewOrderItems,
    getCheckoutSelectedExemptionNeedsEvidence,
    getIdToken,
    getCheckoutInvoiceId,
    getCheckoutIsInvoiceSettled,
    getCheckoutIsSubmittable,
    getUserIsApproved,
    getUserIsSignedUp,
    getUserIsActive,
    getAccessStartToken,
    getUserEmailVerified,
} from '../redux/modules/root-reducer';


export const combine = (...conditions) => state => conditions.reduce((acc, isAllowed) => {
    if (typeof acc === 'string') return acc;
    return isAllowed(state);
}, true);

const conditionalRoute = (testFn, fallbackRoute) => state => (testFn(state) ? true : fallbackRoute);

export const itemsInBasket = conditionalRoute(
    state => getNewOrderItems(state).length > 0,
    paths.createOrder.root,
);

export const loggedIn = conditionalRoute(
    state => getIdToken(state) != null,
    paths.login.root,
);

export const notLoggedIn = conditionalRoute(
    state => getIdToken(state) == null,
    '/',
);

export const waitingLoginComplete = conditionalRoute(
    state => getAccessStartToken(state) !== null,
    paths.login.root,
);

export const userApproved = conditionalRoute(
    state => getUserIsApproved(state),
    paths.signup.waiting,
);

export const userSignedUp = conditionalRoute(
    state => getUserIsSignedUp(state),
    paths.signup.root,
);

export const userNotActive = conditionalRoute(
    state => !getUserIsActive(state),
    '/',
);

export const userEmailVerified = conditionalRoute(
    state => getUserEmailVerified(state),
    paths.signup.verifyemail,
);

export const userNotEmailVerified = conditionalRoute(
    state => !getUserEmailVerified(state),
    '/',
);

export const userActive = conditionalRoute(
    state => getUserIsActive(state),
    paths.signup.consent,
);

export const invoiceNeedsPaying = conditionalRoute(
    state => getCheckoutInvoiceId(state),
    '/',
);

export const requiresEvidence = conditionalRoute(
    state => getCheckoutSelectedExemptionNeedsEvidence(state),
    paths.checkout.declaration,
);

export const invoiceSettled = conditionalRoute(
    state => getCheckoutInvoiceId(state) && getCheckoutIsInvoiceSettled(state),
    paths.checkout.paymentDetails,
);
export const checkoutIsSubmittable = conditionalRoute(
    state => getCheckoutIsSubmittable(state),
    paths.checkout.paymentMethod,
);
